import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServiciosSection from "@/components/ServiciosSection";
import IdentidadSection from "@/components/IdentidadSection";
import DiferencialSection from "@/components/DiferencialSection";
import MetodoSection from "@/components/MetodoSection";
import ServiciosComplementariosSection from "@/components/ServiciosComplementariosSection";
import ContactoSection from "@/components/ContactoSection";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "sonner";

function HomePage() {
  return (
    <div className="App overflow-x-hidden bg-white" data-testid="app-container">
      <SEOHead />
      <Toaster position="top-center" richColors />
      <Header />
      <HeroSection />
      <ServiciosSection />
      <IdentidadSection />
      <DiferencialSection />
      <MetodoSection />
      <ServiciosComplementariosSection />
      <ContactoSection />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
